import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Videos = {
    agregarVideo: async (data) => {
        let url = url_json + "/video"
        // Desde el admin solo se agregan videos de "Más ganadores": el principal es único y no se crea
        let body = {
            campo: data.campo,
            video: data.video,
            titulo: data.titulo,
            vista: 'beca_caav',
            posicion: Number(data.posicion)
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Video agregado correctamente' ,
              'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar el video, codigo: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerVideoCampo: async (campo) => {
        let url = url_json + "/video/campo/" + campo
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarVideo: async (data, id) => {
        let url = url_json + "/video/" + id;
        // campo y vista no se editan; la posición solo aplica a "Más ganadores"
        let body = {
            video: data.video,
            titulo: data.titulo
        };
        if (data.vista === 'beca_caav') body.posicion = Number(data.posicion);
        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Video modificado correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar el video' ,
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    },
    eliminarVideo: async id => {
        let url = url_json + "/video/delete/" + id;
        let request = {
            method: 'PATCH',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Eliminación exitosa!',
                'Video eliminado correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo eliminar el video' ,
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    }
}

export default Videos;
